import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as stateActions from '../../actions/stateActions';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const PaperStyled = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(2)
}));

const SessionHistory = () =>
{
	const dispatch = useDispatch();
	const sessionHistory = useSelector(state => state.sessionHistory);
	
	const setRequestUri = (requestUri) => {
		dispatch(stateActions.setRequestUri({ requestUri }));
	};

	return (
		<PaperStyled>
			{ sessionHistory.length > 0 ?
				<List>
					{ sessionHistory.map((entry, index) =>
					{
						return (
							<ListItem key={index} disablePadding>
								<ListItemButton onClick={() => setRequestUri(entry.sipUri)}>
									<ListItemText
										primary={entry.displayName}
										secondary={entry.sipUri}
									/>
								</ListItemButton>
							</ListItem>
						);
					})}
				</List>
				:
				<Typography
					color='inherit'
					noWrap
				>
					No history
				</Typography>
			}
		</PaperStyled>
	);
};

export default SessionHistory;
